import { Stack, Typography } from "@mui/material";
import { useContext } from "react";
import Image from "src/components/Image";
import useLocales from "src/hooks/useLocales";

import Context from "../../../../../context";

// ----------------------------------------------------------------------

export const EmptyTransfers = () => {
	const { theme } = useContext(Context);
	const { translate } = useLocales();

	return (
		<Stack alignItems={"center"} gap={3} sx={{ height: 250 }}>
			<Image src='/ilustrations/empty_amico.svg' sx={{ width: { xs: 200, sm: 220 } }} />
			<Typography variant='subtitle1' color={theme?.colors.primaryText}>
				{translate("No se han encontrado posiciones")}
			</Typography>
		</Stack>
	);
};

export default EmptyTransfers;
